FavoritesFilters.$inject = ['tn.utils.service.filter'];
export function FavoritesFilters(FilterService) {
    return new FilterService('tn:favorites:filters:changed');
}
